/**
 * Global styles and spacing constants for consistent layout
 */
export const GLOBAL_MARGINS = {
  PAGE_MARGIN: '1rem',
  PAGE_MARGIN_SMALL: '0.5rem',
  PAGE_MARGIN_LARGE: '1.5rem',
};

export const GLOBAL_SPACING = {
  BASE_UNIT: 8,
  SM: '0.375rem',
  MD: '1rem',
  LG: '1.5rem',
};

export default { GLOBAL_MARGINS, GLOBAL_SPACING };
